import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import {
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
} from 'mdb-react-ui-kit';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactPaginate from 'react-paginate';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Form, Menu, Table } from 'semantic-ui-react';
import { DataNotFound } from '../../../../components/DataNotFound';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import AdminBanner from '../../../../components/elements/AdminBanner';
import ImageViewModal from '../../../../components/elements/ImageViewModal';
import SearchFilters from '../../../../components/elements/SearchFilter';
import { getAsync, postAsync } from '../../../../components/helper/axiosHelper';
import { downloadCSV } from '../../../../components/helper/downloadCSVHelper';
import { useLocation } from 'react-router-dom';
import { PageHitCountApi } from '../../../../shared/Helper';
import { printTable } from '../../../../utils/tableExportUtils';
const APIdeaSuggestionList = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [apiData, setApiData] = useState([]);
  const [dateTo, setDateTo] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [gridModalOpen, setGridModalOpen] = useState(false);
  const [gridModalFileOpen, setGridModalFileOpen] = useState(false);
  const [selectedDescriptionData, setSelectedDescriptionData] = useState('');
  const [selectedFileData, setSelectedFileData] = useState('');
  const [pageCount, setPageCount] = useState(1);
  const [isLoad, setIsLoad] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const [next, setNext] = useState(1);
  const [searchTitle, setSearchTitle] = useState('');
  const [applicantName, setApplicantName] = useState('');
  const [pageOptions, setPageOptions] = useState({
    pageNo: 1,
    pageSize: 20,
  });

  const toggleShowOpen = () => setGridModalOpen(!gridModalOpen);
  const { t } = useTranslation();
  const token = localStorage.getItem('token');
  const epUser = localStorage.getItem('apid');
  const { pathname } = useLocation();

  const isLogin = () => {
    if (!token && !epUser) {
      window.location.href = '/managementLogin';
    }
  };
  useEffect(() => {
    const adminID = localStorage.getItem('apid');
    if (adminID) {
      PageHitCountApi(pathname, adminID);
    }
  }, []);

  const bodyGet = {
    epUser: parseInt(epUser),
  };

  const getData = async () => {
    try {
      setIsLoad(true);
      await postAsync(
        `EPIdeaService/EPIdeaServiceFilterList/${pageOptions.pageNo}/${pageOptions.pageSize}`,
        bodyGet,
      ).then((response) => {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response?.page);
        setNext(pageOptions.pageNo);

        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
      });
    } catch (err) {
      console.error(err);
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  useEffect(() => {
    localStorage.setItem('isHome', false);
    isLogin();
    getData();
  }, []);

  const SearchFilter = {
    // epUser: epUser,
    dateFrom: moment(dateFrom).format('DD/MM/YYYY'),
    dateTo: moment(dateTo).format('DD/MM/YYYY'),
    title: searchTitle,
    applicantNameOrMobile: applicantName,
  };

  const getPaginationList = async () => {
    setIsLoad(true);
    setDatanotfound(false);
    await postAsync(
      'EPIdeaService/EPIdeaServiceFilterList/' + pageOptions.pageNo + '/' + pageOptions.pageSize,
      SearchFilter,
    )
      .then((response) => {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response.page);
        setNext(pageOptions.pageNo);
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
        // apiData?.map((data) => {
        //   setPageCount(data?.pageCount);
        // });
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const changePage = async ({ selected }) => {
    const select = selected + 1;
    await postAsync('EPIdeaService/EPIdeaServiceFilterList/' + select + '/' + pageOptions.pageSize, bodyGet)
      .then((response) => {
        setApiData(response?.data);
        setPageCount(response.page);
        setNext(selected + 1);

        // apiData?.map((data) => {
        //   setPageCount(data.pageCount);
        // });
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    await getPaginationList();
  };

  const openModal = (e, ideaServiceID) => {
    e.preventDefault();
    const matchedItem = apiData.find((item) => item.ideaServiceID === ideaServiceID);
    setSelectedDescriptionData(isActive ? matchedItem.descAr || matchedItem.descEn : matchedItem.descEn);

    setGridModalOpen(true);
  };

  const openFileModal = async (e, ideaServiceID) => {
    e.preventDefault();
    try {
      const response = await getAsync('EPIdeaService/EPIdeaServiceListById', { id: ideaServiceID });
      setSelectedFileData(response?.data[0].doc);
    } catch (error) {
      console.log(error);
    }
    setGridModalFileOpen(true);
  };

  const closeFileModal = (e) => {
    e.preventDefault();
    setGridModalFileOpen(false);
  };

  const handleDownload = async (e, id, fileName) => {
    e.preventDefault();
    try {
      const response = await getAsync('EPIdeaService/EPIdeaServiceListById', { id: id });
      const link = document.createElement('a');
      link.href = `data:image/png;base64,${response?.data[0]?.doc}`; // Update MIME type based on your image format
      link.download = fileName || 'image.png'; // Set the desired file name or fallback to 'image.png'
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  // Export xlsl file
  const handleOnExport = () => {
    const filteredData = apiData?.map((item, ii) => ({
      'S.No': ii + 1,
      'Person Name': item.fullName,
      Title: isActive ? item.titleAr : item.titleEn,
      Date: item.date,
      Time: item.timeNow,
      // 'Item Level': item.menuLevelID,
      Description: isActive ? item.descAr : item.descEn,
    }));

    downloadCSV(filteredData, 'APIdea Suggestion List');
  };

  // const handlePrint = (e) => {
  //   e.preventDefault();
  //   const tableContainer = document.createElement('div');
  //   tableContainer.className = 'tableData my-4';

  //   // Create and add the heading
  //   const heading = document.createElement('h1');
  //   heading.className = 'font-bold text-center my-8 sm:text-2xl text-xl text-customgreen';
  //   heading.innerText = `${t('Idea Suggestion List')}`;
  //   tableContainer.appendChild(heading);

  //   const table = document.createElement('table');
  //   table.style.width = '100%';
  //   table.innerHTML = `
  //   <thead style="background-color: #2f855a; color: white;">

  //     <tr>
  //       <th style="padding: 5px; border: 1px solid #ddd;">#</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t('Person Name')}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Title`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Date`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Time`)}</th>

  //     </tr>
  //   </thead>
  //   <tbody>
  //     ${apiData
  //       .map(
  //         (data, index) => `
  //           <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : '#fff'}; border: 1px solid #ddd;">
  //             <td style="padding: 5px; border: 1px solid #ddd;">${index + 1}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.fullName || 'N/A'}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.titleEn || 'N/A'}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.date}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.timeNow || 'N/A'}</td>

  //           </tr>
  //         `,
  //       )
  //       .join('')}
  //   </tbody>
  // `;

  //   tableContainer.appendChild(table);
  //   document.body.appendChild(tableContainer);

  //   // Add CSS to hide everything except the table when printing
  //   const style = document.createElement('style');
  //   style.textContent = `
  //   @media print {

  //     body * {
  //       visibility: hidden;
  //       height: 0;

  //     }
  //     .tableData, .tableData * {
  //       visibility: visible;
  //     }
  //     .tableData {
  //       position: absolute;
  //       left: 0;
  //       top: 0;
  //       width: 100%;
  //       height: auto;
  //       overflow: visible;
  //     }
  //   }
  // `;
  //   document.head.appendChild(style);

  //   // Trigger the print dialog
  //   window.print();

  //   // Clean up by removing the table container and style from the DOM
  //   document.body.removeChild(tableContainer);
  //   document.head.removeChild(style);

  //   return 'success';
  // };
const handlePrint = (e) => {
  e.preventDefault();
  
  // Column configuration
  const columns = [
    {
      header: t('sNo'),
      accessor: (row, index) => index + 1
    },
    {
      header: t('Person Name'),
      accessor: (row) => isActive ? row?.fullName : row?.fullName
    },
     {
      header: t('Title'),
      accessor: (row) => isActive ? row?.titleEn : row?.titleEn
    },   {
      header: t('Date'),
      accessor: (row) => isActive ? row?.date  || 'N/A' : row?.date  || 'N/A'
    },   {
      header: t('Time'),
      accessor: (row) => isActive ? row?.timeNow  || 'N/A' : row?.timeNow|| 'N/A'
    }

  ];
  
  // Call the reusable print function
  printTable({
    data: apiData || [],
    isRTL: isActive, // isActive true = Arabic = RTL
    t: t,
    title: `${t('Idea Suggestion List')} `,
    columns: columns,
    onBeforePrint: () => {
      console.log('Printing started...');
      // toast.info(t('Preparing print preview...'));
    },
    onAfterPrint: () => {
      console.log('Printing completed');
    },
    styles: {
      customCSS: `
        /* Additional custom styles if needed */
        .print-table th {
          font-weight: 600;
        }
        @media print {
          .print-title {
            color: #000 !important;
          }
        }
      `
    }
  });
};
  const displayRecords = apiData?.map((data, index) => {
    const sno = (next - 1) * pageOptions.pageSize + index + 1;
    return (
      <Table.Row key={index} items={apiData}>
        <Table.Cell>{sno}</Table.Cell>
        <Table.Cell>{data?.fullName}</Table.Cell>
        <Table.Cell>{isActive ? data?.titleAr || 'N/A' : data?.titleEn || 'N/A'}</Table.Cell>
        <Table.Cell>{data?.date}</Table.Cell>
        <Table.Cell>{data?.timeNow}</Table.Cell>
        <Table.Cell>
          <>
            <button
              className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
              onClick={(e) => openModal(e, data?.ideaServiceID)}
            >
              <VisibilityOutlinedIcon />
            </button>
          </>
        </Table.Cell>
        <Table.Cell>
          <button
            className="text-white w-20  bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
            onClick={(e) => handleDownload(e, data?.ideaServiceID, data?.fileName)}
          >
            <FileDownloadOutlinedIcon />
          </button>
          <div className='mt-2'></div>
          <button
            className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
            type="button"
            onClick={(e) => openFileModal(e, data?.ideaServiceID)}
          >
            <VisibilityOutlinedIcon />
          </button>
        </Table.Cell>
      </Table.Row>
    );
  });

  return (
    <div className="">
      {!isLogin ? (
        <h1>NOT AUTHORIZED</h1>
      ) : (
        <>
          <div className="container-fluid">
            <div className="row justify-center py-5 mt-3">
              <SearchFilters
                handleSearch={handleSearch}
                setDateFrom={setDateFrom}
                setDateTo={setDateTo}
                dateTo={dateTo}
                dateFrom={dateFrom}
                handlePrint={handlePrint}
                handleOnExport={handleOnExport}
                heading={'Idea Suggestion List'}
                setApplicantName={setApplicantName}
                isTitleVisible={true}
                setSearchTitle={setSearchTitle}
                isApplicantName={true}
              />

              <MDBModal tabIndex="-1" show={gridModalOpen} setShow={setGridModalOpen}>
                <MDBModalDialog>
                  <MDBModalContent className="bg-green-50">
                    <Form>
                      <MDBModalHeader className="text-customgreen font-semibold flex justify-center items-center">
                        <MDBModalTitle>{t('Description')}</MDBModalTitle>
                        {/* <MDBBtn type="button" className="btn-close" color="none" onClick={toggleShowOpen}></MDBBtn> */}
                      </MDBModalHeader>
                      <MDBModalBody>
                        <div style={{ minHeight: 200 }} className="container-fluid bd-example-row">
                          {selectedDescriptionData}
                        </div>
                      </MDBModalBody>
                      <MDBModalFooter>
                        <button
                          className="text-white hover:text-white bg-customgreen border-2 border-customgreen hover:bg-hovergreen focus:ring-4 focus:outline-none focus:ring-customgreen font-medium rounded-full text-sm px-4 py-2 text-center me-2"
                          onClick={toggleShowOpen}
                        >
                          {t('close')}
                        </button>
                      </MDBModalFooter>
                    </Form>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>

              <div className="col-xl-11 pt-9 ">
                <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                  {isLoad ? (
                    <LoadingAnimation />
                  ) : (
                    <Table className="text-sm tableData text-left rtl:text-right ">
                      <Table.Header className=" text-white text-center bg-customgreen uppercas">
                        <Table.Row>
                          <Table.HeaderCell className="text-white">{t('sNo')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Person Name')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Title')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Date')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Time')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Description')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white ">{t('File')}</Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>

                      <Table.Body className="text-center">{displayRecords}</Table.Body>
                    </Table>
                  )}
                  {datanotfound && <DataNotFound />}
                </div>
                {/* ImageViewModal */}
                <ImageViewModal
                  showModal={gridModalFileOpen}
                  setShowModal={setGridModalFileOpen}
                  closeModal={closeFileModal}
                  title={''}
                  renderLink={''}
                  imgDoc={selectedFileData}
                />
                {pageCount > 0 && (
                  <div className="flex flex-row px-12 justify-between">
                    <Menu pagination>
                      <Menu.Item>
                        <ReactPaginate
                          previousLabel={t('Previous')}
                          nextLabel={t('Next')}
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={'paginationButtons'}
                          previousLinkClassName={'previousButton'}
                          nextLinkClassName={'nextButton'}
                          disabledClassName={'paginationDisabled'}
                          activeClassName={'paginationActive'}
                        />
                      </Menu.Item>
                    </Menu>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default APIdeaSuggestionList;
